// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"56faf071","646":"7444d4cb"}[chunkId] + ".chunk.js";
};